﻿import CustomNavigation from "./custom.class.navigation.js";


/**
 * Clientseitige Funktionalität im Modul "Navigation"
 *
 * @module navigation
 */


export const opaccNavigationPlugin = new CustomNavigation();